import React from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../SEO/PageMeta';
import logoImg from '../../assets/logo.png';
import './Pages.css';

const EMAIL = 'imomujjwalsingh@gmail.com';

const BLOCKS = [
  { title: 'Collected', tone: 'rust', items: ['Name and email', 'Phone, if added', 'Study activity: cards, scores, streaks', 'Device and browser data'] },
  { title: 'Used for', tone: 'teal', items: ['Your revision schedule', 'OTPs and account notices', 'Newsletter, if you subscribe', 'Improving content'] },
  { title: 'Never', tone: 'gold', items: ['Selling your data', 'Sharing your email with advertisers', 'Ads based on personal data'] },
  { title: 'Storage', tone: 'sage', items: ['MongoDB Atlas', 'Passwords hashed with bcrypt', 'HTTPS for all traffic'] },
  { title: 'Your rights', tone: 'rust', items: ['Delete your account from Profile', 'Export or deletion on request', <a key="m" href={`mailto:${EMAIL}`}>{EMAIL}</a>] },
  { title: 'Cookies', tone: 'teal', items: ['Login only', 'No tracking or ad cookies'] },
];

export default function PrivacyPage() {
  return (
    <div className="pg">
      <PageMeta
        title="Privacy Policy | CivilFox"
        description="Read how CivilFox handles account information, study activity, security, cookies, data retention, and privacy requests."
        path="/privacy"
      />
      <header className="pg-top">
        <Link to="/" aria-label="CivilFox home"><img src={logoImg} alt="CivilFox" /></Link>
      </header>
      <main className="pg-main">
        <h1>Privacy policy</h1>
        <p>How CivilFox collects, uses, stores, and protects information when you use the service.</p>
        <div className="pg-policy">
          <div className="pg-blocks">
            {BLOCKS.map(b => (
              <section key={b.title} className={`pg-block ${b.tone}`}>
                <h2>{b.title}</h2>
                <ul>{b.items.map((it, i) => <li key={i}>{it}</li>)}</ul>
              </section>
            ))}
          </div>
          <p className="pg-updated">Updated May 2026</p>
        </div>
      </main>
    </div>
  );
}